import { render, staticRenderFns } from "./my-account-dropdown.vue?vue&type=template&id=62a100b0&scoped=true&lang=pug&"
import script from "./my-account-dropdown.vue?vue&type=script&lang=js&"
export * from "./my-account-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./my-account-dropdown.vue?vue&type=style&index=0&id=62a100b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a100b0",
  null
  
)

component.options.__file = "my-account-dropdown.vue"
export default component.exports